/**
 * Base Formatter class - defines the interface for custom Formatters
 */
export class Formatter {
  format() {
    throw new Error('Not Implemented');
  }
}



// WEBPACK FOOTER //
// ./d:/dbs/el/aapusc/private/client-instrumentation/packages/listener/src/formatter.es